module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step2b_Image15j.ae1d097e.jpg";